module.exports = __webpack_public_path__ + "static/media/1 samurai ronin demon oni mask katana japanese melbourne tattoo .1280x1570.697fa6e5.webp";